import React, { useState } from "react";
import { Typography, Button, TextField } from "@mui/material";
import { StyledCard, CardHeader, TopBtnBox } from "./styles";
import {
  useDeleteMachineMaster,
  usePutData,
  usePutMachineMaster,
} from "../Plan/tableHooks";
import { DeleteButton, EditButton } from "../../common/Buttons";

function EquipmentCard({
  equipment,
  setUpdateStatus,
  group_code,
  project_code,
  openSnackbar,
}) {
  const [isEditing, setIsEditing] = useState(false);
  const [editedName, setEditedName] = useState(equipment.name);
  const deleteMchUsableProc = useDeleteMachineMaster(
    null,
    "/api/mch/deleteMchM"
  );
  const updateMutation = usePutData(
    null,
    `/api/mch/putOriginalName`,
    openSnackbar
  );
  const deleteMchMaster = async (machine_id) => {
    try {
      await deleteMchUsableProc.mutateAsync({
        machine_id,
        group_code,
        project_code,
      });
      setUpdateStatus((prev) => !prev);
    } catch (e) {
      console.log(e);
    }
  };
  const handleEditStart = () => {
    setIsEditing(true);
  };
  const updateMachineMaster = usePutMachineMaster(null, "/api/mch/updateMchM");
  const handleEditComplete = async () => {
    try {
      const arr = [group_code, project_code, equipment.machine_id, editedName];
      await updateMachineMaster.mutateAsync(arr, {
        onSuccess: () => {
          setIsEditing(false);
          setUpdateStatus((prev) => !prev);
        },
        onError: (e) => {
          console.log(e);
        },
      });
    } catch (e) {
      console.log(e);
    }
  };
  const onClickUseOriginalName = async (machine_id) => {
    const obj = {
      group_code,
      project_code,
      data: machine_id,
    };
    await updateMutation.mutateAsync(obj, {
      onSuccess: () => {
        setIsEditing(false);
        setUpdateStatus((prev) => !prev);
      },
    });
  };
  return (
    <StyledCard>
      <CardHeader>
        {isEditing ? (
          <TextField
            value={editedName}
            onChange={(e) => setEditedName(e.target.value)}
            variant="outlined"
            size="small"
            fullWidth
            autoFocus
            sx={{ maxWidth: "45%" }}
          />
        ) : (
          <div
            style={{ display: "flex", gap: "0.5rem", alignItems: "flex-end" }}
          >
            <Typography variant="h5">{equipment.name}</Typography>
            {equipment.original_name && (
              <Typography variant="h7">({equipment.original_name})</Typography>
            )}
          </div>
        )}
        <TopBtnBox>
          {isEditing ? (
            <div style={{ display: "flex", gap: "0.5rem" }}>
              {equipment.original_name &&
                equipment.original_name !== equipment.name && (
                  <Button
                    onClick={() => onClickUseOriginalName(equipment.machine_id)}
                  >
                    원명사용?
                  </Button>
                )}
              <Button
                variant="contained"
                color="success"
                onClick={handleEditComplete}
              >
                수정완료
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setIsEditing(false);
                  setEditedName(equipment.name);
                }}
              >
                수정취소
              </Button>
            </div>
          ) : (
            <EditButton
              variant="contained"
              color="secondary"
              onClick={handleEditStart}
            />
          )}
          {!isEditing && (
            <DeleteButton
              variant="contained"
              color="error"
              onClick={() => deleteMchMaster(equipment.machine_id)}
            />
          )}
        </TopBtnBox>
      </CardHeader>
    </StyledCard>
  );
}

export default EquipmentCard;
